import {
  FileItem,
  FileLikeObject,
  FileUploader,
  FileUploaderOptions,
  ParsedResponseHeaders
} from '../../ng2-file-upload/file-uploader.class';
import {IFileDataProperties, ImageDataConverter} from './imageDataConverter.service';
import {FilemanagerNotifcations, INotification} from './FilemanagerNotifcations';
import {AlertService} from "../../../_services";
import {AppModule} from "../../../app.module";
import {Constants} from "../../../helpers/constants";

export class ExtendedFileUploader extends FileUploader {

  public constructor(options: FileUploaderOptions, public alertService: AlertService) {
    super({url: (window.location.origin || Constants.DefaultApiHost) + '/api/documents/filesAll'});
  }

  public onWhenAddingFileFailed(item: FileLikeObject, filter: any, options: FileUploaderOptions) {
    const notification: INotification = {
      type: 'alert',
      title: 'Add file to queue',
      message: `File not add to queue`
    };

    if (filter.name === 'fileSize') {
      notification.message = `File size is too large - max size  is ${options.maxFileSize / 1024} KB`;
    } else {
      notification.message = `File mime type "${item.type}" is not allowed`;
    }
    this.alertService.error(notification);
  }

  public uploadItem(value: FileItem): void {
    //TODO :: Why?
    this.options.url = (window.location.origin || Constants.DefaultApiHost) + '/api/documents/filesAll';
    value.url = (window.location.origin || Constants.DefaultApiHost) + '/api/documents/filesAll';
    if (this.options.url) {
      super.uploadItem(value);
    } else {
      const imageDataConverter = new ImageDataConverter();
      //this._onProgressItem(value, 0);

      if (this.isUploading) {
        return;
      }

      this.isUploading = true;
      const header = this.options.headers.find((object: any) => object.name === 'folderId');

      //this._onProgressItem(value, 50);
      imageDataConverter.getProperties(value._file, header.value)
        .subscribe((file: IFileDataProperties) => {
          this.isUploading = false;

//          this._onProgressItem(value, 100);
          //this._onCompleteItem(value, JSON.stringify(file), 200, {});
        });
    }
  }

  public onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    AppModule.injector.get<any>(AlertService).error(response);
    //return super.onErrorItem(item, response, status, headers);
  }
}
